import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../LanguageContext'
import { LanguageSelector } from '../LanguageSelector'
import { translations } from '../translations'
import "../styles/home.css"
import ss1 from "../pictures/ss1.jpg"
import ss2 from "../pictures/ss2.jpg"
import ss3 from "../pictures/ss3.jpeg"
import h1 from "../pictures/h1.jpg"
import h2 from "../pictures/h2.jpg"
import h3 from "../pictures/h3.jpg"
import h4 from "../pictures/h4.jpg"
import h5 from "../pictures/h5.jpg"
import h6 from "../pictures/h6.jpg"
import logo from "../pictures/logonav.png";

// Import your video file here - replace with your actual video path
import videoSlide from "../videos/gymfloor.mp4"

import pp1 from "../pictures/veldfarm (1).png"
import pp2 from "../pictures/veldfarm (2).png"
import pp3 from "../pictures/veldfarm (3).png"
import pp4 from "../pictures/veldfarm (4).png"

import veldfoter from "../pictures/veldfooter.png"

import GlobalBranchesCarousel from '../components/Globalbranchescarousel';

function useInView(threshold = 0.1) {
  const ref = useRef(null)
  const [inView, setInView] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setInView(true) },
      { threshold }
    )
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [threshold])
  return [ref, inView]
}

function OfferingCard({ item, index, t }) {
  const [ref, inView] = useInView(0.08)
  return (
    <div ref={ref} className={`offer-card ${inView ? 'card-visible' : ''}`} style={{ '--delay': `${index * 0.08}s` }}>
      <div className="offer-img-wrap">
        <div className="offer-img" style={{ backgroundImage: `url(${item.image})` }} />
        <span className="offer-num">{item.label}</span>
      </div>
      <div className="offer-body">
        <h3 className="offer-title">{item.title}</h3>
        <div className="offer-bar" />
        <p className="offer-desc">{item.desc}</p>
        <Link to="/products" className="offer-btn">Shop Now</Link>
      </div>
    </div>
  )
}

function FeatCard({ feature, index }) {
  const [ref, inView] = useInView(0.08)
  return (
    <div
      ref={ref}
      className={`feat-card ${inView ? 'feat-visible' : ''}`}
      style={{ '--delay': `${index * 0.07}s`, '--feat-color': feature.color }}
    >
      <div className="feat-dot" />
      <div className="feat-text">
        <span className="feat-sub">{feature.sub}</span>
        <h3 className="feat-title">{feature.title}</h3>
      </div>
    </div>
  )
}

function ProductDropdown({ t }) {
  const { language } = useLanguage()
  
  const productCategories = [
    { id: 'veldfarm', title: 'VeldFarm®', subtitle: 'Cattle & Stable Flooring', image: h4 },
    { id: 'veldfit', title: 'VeldFit®', subtitle: 'Gym & Play Flooring', image: h2 },
    { id: 'veldguard', title: 'VeldGuard®', subtitle: 'Industrial & Anti-Fatigue Mats', image: h3 },
    { id: 'veldhome', title: 'VeldHome®', subtitle: 'Domestic & Commercial Mats', image: h5 },
  ]

  const scrollToSection = (id) => {
    setTimeout(() => {
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }, 100)
  }

  return (
    <div className="product-dropdown">
      <div className="dropdown-content">
        <div className="dropdown-grid">
          {productCategories.map((category) => (
            <Link 
              key={category.id} 
              to="/products" 
              onClick={() => scrollToSection(category.id)}
              className="dropdown-item"
            >
              <div className="dropdown-img-wrap">
                <div 
                  className="dropdown-img" 
                  style={{ backgroundImage: `url(${category.image})` }} 
                />
              </div>
              <div className="dropdown-info">
                <h4 className="dropdown-title">{category.title}</h4>
                <p className="dropdown-desc">{category.subtitle}</p>
              </div>
            </Link>
          ))}
        </div>
        <div className="dropdown-footer">
          <Link to="/products" className="dropdown-view-all">
            View All Products
          </Link>
        </div>
      </div>
    </div>
  )
}

function Home() {
  const { language, isLoading } = useLanguage()
  // Always use translations - with fallback to English
  const t = translations[language] || translations.en
  
  const [current, setCurrent] = useState(0)
  const [animating, setAnimating] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [productDropdownOpen, setProductDropdownOpen] = useState(false)
  const [headerRef, headerInView] = useInView(0.15)
  const [qualRef, qualInView] = useInView(0.1)
  const productNavRef = useRef(null)

  const slides = [
    {
      type: 'video',
      video: videoSlide,
      tag: t.hero.slide1_tag,
      heading: t.hero.slide1_heading,
      sub: t.hero.slide1_sub,
      cta: t.hero.slide1_cta,
    },
    {
      type: 'image',
      image: ss2,
      tag: t.hero.slide2_tag,
      heading: t.hero.slide2_heading,
      sub: t.hero.slide2_sub,
      cta: t.hero.slide2_cta,
    },
    {
      type: 'image',
      image: ss1,
      tag: t.hero.slide3_tag,
      heading: t.hero.slide3_heading,
      sub: t.hero.slide3_sub,
      cta: t.hero.slide3_cta,
    },
  ]

  const categories = [
    { id:1, label:"01", title: t.offerings.category_01, desc: t.offerings.category_01_desc, image: h1 },
    { id:2, label:"02", title: t.offerings.category_02, desc: t.offerings.category_02_desc, image: h2 },
    { id:3, label:"03", title: t.offerings.category_03, desc: t.offerings.category_03_desc, image: h3 },
    { id:4, label:"04", title: t.offerings.category_04, desc: t.offerings.category_04_desc, image: h4 },
    { id:5, label:"05", title: t.offerings.category_05, desc: t.offerings.category_05_desc, image: h5 },
    { id:6, label:"06", title: t.offerings.category_06, desc: t.offerings.category_06_desc, image: h6 },
  ]

  const features = [
    { title: t.quality.recyclable, sub: t.quality.recyclable_sub, color:"#4caf85" },
    { title: t.quality.antiSlip, sub: t.quality.antiSlip_sub, color:"#E8012E" },
    { title: t.quality.antiFatigue, sub: t.quality.antiFatigue_sub, color:"#f5a623" },
    { title: t.quality.oilResistant, sub: t.quality.oilResistant_sub, color:"#c8a044" },
    { title: t.quality.waterResistant, sub: t.quality.waterResistant_sub, color:"#4a9eca" },
    { title: t.quality.nonToxic, sub: t.quality.nonToxic_sub, color:"#7ab648" },
    { title: t.quality.fireResistant, sub: t.quality.fireResistant_sub, color:"#ff6b35" },
  ]

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30)
    window.addEventListener('scroll', h)
    return () => window.removeEventListener('scroll', h)
  }, [])

  useEffect(() => {
    const t = setInterval(() => triggerSlide((current + 1) % slides.length), 6000)
    return () => clearInterval(t)
  }, [current, slides.length])

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (productNavRef.current && !productNavRef.current.contains(e.target)) {
        setProductDropdownOpen(false)
      }
    }
    
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const triggerSlide = (index) => {
    if (index === current) return
    setAnimating(true)
    setTimeout(() => { setCurrent(index); setAnimating(false) }, 500)
  }

  const closeMenu = () => setMenuOpen(false)
  const slide = slides[current]

  return (
    <div className="homemain" dir={language === 'ar' ? 'rtl' : 'ltr'}>

      {/* NAV */}
      <nav className={`menus ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="logo-link">
<div className='lgimagecont'>
  <img src={logo} alt="Company Logo" className="logo-img" />
</div>
</Link>

        <div className="options">
          <ul>
            <li><Link to="/">{t.nav.home}</Link></li>
            <li 
              className="products-nav-item"
              ref={productNavRef}
              onMouseEnter={() => setProductDropdownOpen(true)}
              onMouseLeave={() => setProductDropdownOpen(false)}
            >
              <Link to="/products">{t.nav.products}</Link>
              {productDropdownOpen && <ProductDropdown t={t} />}
            </li>
            {/* <li><a href="#">{t.nav.about}</a></li> */}
            <li><Link to="/contact">{t.nav.contact}</Link></li>
          </ul>
          <a href="#" className="nav-cta">{t.nav.quote}</a>
        </div>

        <LanguageSelector />

        <button
          className={`ham-btn ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(p => !p)}
          aria-label="Toggle menu"
        >
          <span className="bar" />
          <span className="bar" />
        </button>
      </nav>

      <div className={`mobile-menu ${menuOpen ? 'active' : ''}`}>
        <ul>
          <li onClick={closeMenu}><Link to="/">{t.nav.home}</Link></li>
          <li onClick={closeMenu}><Link to="/products">{t.nav.products}</Link></li>
          {/* <li onClick={closeMenu}><a href="#">{t.nav.about}</a></li> */}
          <li onClick={closeMenu}><Link to="/contact">{t.nav.contact}</Link></li>
        </ul>
      </div>
      {menuOpen && <div className="overlay" onClick={closeMenu} />}

      {/* HERO */}
      <div className="land">
        <div className="gymslides">
          {slide.type === 'video' ? (
            <video
              key={current}
              className={`slide-video ${animating ? 'video-out' : 'video-in'}`}
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={slide.video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div
              className={`slide-bg ${animating ? 'bg-out' : 'bg-in'}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            />
          )}
          <div className="slide-overlay" />

          <div className={`slide-content ${animating ? 'content-out' : 'content-in'}`}>
            <span className="slide-tag">{slide.tag}</span>
            <h1 className="slide-heading">
              {slide.heading.split('\n').map((line, i) => (
                <span key={i} className="heading-line">{line}</span>
              ))}
            </h1>
            <p className="slide-sub">{slide.sub}</p>
            <Link to="/products" className="slide-cta">{slide.cta}</Link>
          </div>

          <div className="slide-dots">
            {slides.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === current ? 'active' : ''}`}
                onClick={() => triggerSlide(i)}
              />
            ))}
          </div>

          <div className="slide-counter">
            <span className="count-current">0{current + 1}</span>
            <span className="count-sep">&nbsp;/&nbsp;</span>
            <span className="count-total">0{slides.length}</span>
          </div>
        </div>
      </div>

      {/* OFFERINGS */}
      <div className="offerings">
        <div ref={headerRef} className={`offerings-header ${headerInView ? 'header-visible' : ''}`}>
          <span className="offerings-eyebrow">{t.offerings.eyebrow}</span>
          <h2 className="offerings-heading">{t.offerings.heading}</h2>
          <p className="offerings-subhead">
            {t.offerings.subhead}
          </p>
        </div>

        <div className="offerings-grid">
          {categories.map((item, i) => (
            <OfferingCard key={item.id} item={item} index={i} t={t} />
          ))}
        </div>

        <div className={`offerings-cta-row ${headerInView ? 'cta-visible' : ''}`}>
          <p>{t.offerings.cta_text}</p>
          <Link to="/products" className="offerings-cta-btn">
            <span>{t.offerings.cta_btn}</span>
          </Link>
        </div>
      </div>

      {/* QUALITY */}
      <div className="quality">
        <div ref={qualRef} className={`quality-header ${qualInView ? 'q-header-visible' : ''}`}>
          <span className="quality-eyebrow">{t.quality.eyebrow}</span>
          <h2 className="quality-heading">{t.quality.heading}</h2>
          <p className="quality-subhead">
            {t.quality.subhead}
          </p>
        </div>
        <div className="quality-grid">
          {features.map((f, i) => (
            <FeatCard key={i} feature={f} index={i} />
          ))}
        </div>
      </div>

      {/* GLOBAL BRANCHES - Pass language prop */}
      <GlobalBranchesCarousel language={language} />

      {/* FOOTER */}
      <footer className="site-footer">
        <div className="footer-inner">

          <div className="footer-brand">
                <Link to="/" className="logo-link">
<div className='lgimagecont'>
  <img src={veldfoter} alt="Company Logo" className="logo-img" />
</div>
</Link>
            <p className="footer-tagline">
              {t.footer.tagline}
            </p>
            <div className="footer-socials">
              {[
                <svg key="ig" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
                </svg>,
                <svg key="fb" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>,
                <svg key="li" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>,
              ].map((icon, i) => (
                <a key={i} href="#" className="social-icon">{icon}</a>
              ))}
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">{t.footer.products_title}</h4>
            <ul>
              <li><Link to="/products">{t.footer.prod_industrial}</Link></li>
              <li><Link to="/products">{t.footer.prod_antifatigue}</Link></li>
              <li><Link to="/products">{t.footer.prod_indoor}</Link></li>
              <li><Link to="/products">{t.footer.prod_cattle}</Link></li>
              <li><Link to="/products">{t.footer.prod_domestic}</Link></li>
              <li><Link to="/products">{t.footer.prod_commercial}</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">{t.footer.company_title}</h4>
            <ul>
              <li><a href="#">{t.footer.company_about}</a></li>
              <li><a href="#">{t.footer.company_certifications}</a></li>
              <li><a href="#">{t.footer.company_careers}</a></li>
              <li><a href="#">{t.footer.company_privacy}</a></li>
            </ul>
          </div>

          <div className="footer-col footer-contact">
            <h4 className="footer-col-title">{t.footer.contact_title}</h4>
            <ul>
              <li>
                <span className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                    <circle cx="12" cy="10" r="3"/>
                  </svg>
                </span>
                {t.footer.contact_address}
              </li>
              <li>
                <span className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </span>
                <a href="mailto:demalabarkitchen@gmail.com">{t.footer.contact_email}</a>
              </li>
              <li>
                <span className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.36 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.27 1.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l1.27-.63a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </span>
                <a href="tel:063754623">{t.footer.contact_phone}</a>
              </li>
              <li>
                <span className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2"/>
                    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                  </svg>
                </span>
                {t.footer.contact_kvk}
              </li>
              <li>
                <span className="contact-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                  </svg>
                </span>
                {t.footer.contact_btw}
              </li>
            </ul>
            <a href="mailto:malabarmatseurope@gmail.com" className="footer-cta-link">
              {t.footer.contact_message}
            </a>
          </div>

        </div>
        <div className="footer-bottom">
       
          <span>{t.footer.copyright.replace('{year}', new Date().getFullYear())}</span>
          <span>{t.footer.location}</span>
        </div>
      </footer>

    </div>
  )
}

export default Home